<a *ngIf="forceVisible || (stateService.isHelpModeActivated$ | async)" class="pi pi-question-circle text-info mx-1" [ngbTooltip]="tip"></a>
